import React from "react";
import MainDrawingWrapper from "../../components/lotto5/MainDrawingWrapper";
import DashboardMix from "../../components/lotto5/mix/DashboardMix";
import BettingDialog from "../../components/lotto5/BettingDialog";
import { useLotto5 } from "../../store/lotto5/Lotto5Context";

const Lotto5DashboardMix = ({ appClass = "" }) => {
    return <MainDrawingWrapper appClass={appClass} stSize={{ row: 6, column: 7 }} isIframe={true}>
        <Lotto5MixWrapper appClass={appClass} />
    </MainDrawingWrapper>
}


const Lotto5MixWrapper = ({ appClass }) => {
    const lotto = useLotto5();
    return <div className="lotto5-mix m-lotto-1">
        <DashboardMix appClass={appClass}/>
        <BettingDialog appClass={appClass} {...lotto} classDialog="bet-mix-dialog" />
    </div>
}

export default Lotto5DashboardMix;
